// const url = 'http://localhost:6060';
const url = "https://vb-seller-server.herokuapp.com";

export default url;
